import React from 'react';
import ReactDOM from 'react-dom/client';
import { TitaniaApp } from './TitaniaApp';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
  <TitaniaApp />
  //</React.StrictMode>
);
